import React from 'react'
import { Switch, Route } from 'react-router-dom'
import Admin from './pages'
import Custom from './pages/custom'
import Ghost from './pages/ghost'
import Transfer from './pages/transfer'
import { AuthProvider } from './providers/AuthProvider'
import Trial from './pages/trial'

export default function App() {
  return (
    <AuthProvider>
      <Switch>
        <Route path="/ghost" component={Ghost} />
        <Route path="/transfer" component={Transfer} />
        <Route path="/custom" component={Custom} />
        <Route path="/trial" component={Trial} />
        <Route path="/" component={Admin} />
      </Switch>
    </AuthProvider>
  )
}
